module.exports = __webpack_public_path__ + "static/logo-82979bad464140bb79c89c71b52ed1f7.svg";